import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

// Sessions are namespaced by restaurant slug so opening a second restaurant's
// portal link doesn't clobber a session in another tab.
const tokenKey = (slug) => `eez7_guest_portal_token::${slug || "default"}`;
const emailKey = (slug) => `eez7_guest_portal_email::${slug || "default"}`;

export const getPortalToken = (slug) => localStorage.getItem(tokenKey(slug)) || "";
export const getPortalEmail = (slug) => localStorage.getItem(emailKey(slug)) || "";
export const setPortalSession = (slug, token, email) => {
  localStorage.setItem(tokenKey(slug), token);
  localStorage.setItem(emailKey(slug), email);
};
export const clearPortalSession = (slug) => {
  localStorage.removeItem(tokenKey(slug));
  localStorage.removeItem(emailKey(slug));
};

const portalHeaders = (slug) => {
  const token = getPortalToken(slug);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchRestaurantBySlug = async (slug) => {
  const r = await axios.get(`${BASE_API}/guest-portal/restaurant/${encodeURIComponent(slug)}`);
  return r.data;
};

export const requestOtp = async (email, restaurantId) => {
  const r = await axios.post(`${BASE_API}/guest-portal/request-otp`, {
    email,
    restaurantId,
  });
  return r.data;
};

export const verifyOtp = async (slug, email, otp, restaurantId) => {
  const r = await axios.post(`${BASE_API}/guest-portal/verify-otp`, {
    email,
    otp,
    restaurantId,
  });
  if (r.data?.token) setPortalSession(slug, r.data.token, email);
  return r.data;
};

export const fetchHistory = async (slug) => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/history`, {
    headers: portalHeaders(slug),
  });
  return r.data;
};

export const fetchUpcomingReservations = async (slug) => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/upcoming-reservations`,
    { headers: portalHeaders(slug) },
  );
  return r.data;
};

export const fetchUpcomingEventOrders = async (slug) => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/upcoming-events`, {
    headers: portalHeaders(slug),
  });
  return r.data;
};

export const createGuestRequest = async (slug, payload) => {
  const r = await axios.post(
    `${BASE_API}/guest-portal/me/requests`,
    payload,
    { headers: portalHeaders(slug) },
  );
  return r.data;
};

export const fetchMyRequests = async (slug) => {
  const r = await axios.get(`${BASE_API}/guest-portal/me/requests`, {
    headers: portalHeaders(slug),
  });
  return r.data;
};

export const fetchTransferTargets = async (slug, orderId) => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/orders/${orderId}/transfer-targets`,
    { headers: portalHeaders(slug) },
  );
  return r.data;
};

export const cancelMyRequest = async (slug, requestId) => {
  const r = await axios.delete(
    `${BASE_API}/guest-portal/me/requests/${requestId}`,
    { headers: portalHeaders(slug) },
  );
  return r.data;
};

export const fetchRescheduleSlots = async (slug, reservationId, date) => {
  const r = await axios.get(
    `${BASE_API}/guest-portal/me/reservations/${reservationId}/available-slots`,
    { headers: portalHeaders(slug), params: { date } },
  );
  return r.data;
};
